import(/* webpackMode: "eager" */ "/codebuild/output/src1783294825/src/patient-app/app/global-error.tsx");
